import { SeriesApi } from '../../generated/api';
import configuration from './configuration';

export default new SeriesApi(configuration);
